
import { SentidoRota } from "./sentido-rota.enum";

export function SentidoRotaAware(constructor: Function){
    constructor.prototype.SentidoRota = SentidoRota;
}